import styled from 'styled-components';

export const TodoListWrapperStyled = styled.div`
    align-self: flex-start;
    width: 100%;
`;

export const TodoListStyled = styled.div`
    display: flex;
    flex-direction: column;

    & > button {
        align-self: flex-end;
    }
`;

export const TodoListItemStyled = styled.div`
    font-size: 30px;
    border-bottom: 1px solid #C5C5C5;
    padding: 15px 0px;
    text-decoration: ${props  => props.completed ? 'line-through' : 'none'};
    color: ${function(props) {
        if(props.completed) {
            return '#FF8484'
        } else if(localStorage.getItem('theme') === 'dark' && !props.completed) {
            return 'white'
        } else {
            return 'initial'
        }
    }};
    cursor: pointer;

    &:hover {
       span{
           &:nth-child(1) {
               color: #FF5733;
           }
       }
    }

    & > span {
        font-weight: 500;
    }

    @media screen and (max-width: 576px){
        font-size: 23px;
    }
`;

export const Index = styled.span`
    color: #A9A9A9;
    min-width: 30px;
    display: inline-block;
`;

export const Text = styled.span`
    margin: 0px 0px 0px 10px;
`;